<template>
  <div class="jukaApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" @resize="handleResize">
    <headComponent></headComponent>
    <div style="height:36px"></div>
    <div class="banner">
      <swiper :options="swiperOption">
        <swiper-slide class="swiper-slide" v-for="(item,i) in setAdvert">
          <a><img :src="baseUrl+item.banner"></a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav">
      <a @click="gatherHref">
        <img src="~assets/images/nav6.png"/>
        <p>聚卡激活</p>
      </a>
      <a @click="$router.push('jukactive')">
        <img src="~assets/images/nav1.png"/>
        <p>活动线路</p>
      </a>
      <a @click="kfz">
        <img src="~assets/images/kjk.png"/>
        <p>视频号转发</p>
      </a>
      <a @click="kfz">
        <img src="~assets/images/nav7.png"/>
        <p>图库围观</p>
      </a>
      <div class="noty">
        <p><i class="el-icon-message-solid"></i>悠乐聚卡火热更新上线啦，更多板块持续上新！</p>
      </div>
    </div>

    <div class="active" v-if="setActive.length > 0">
      <h2>
        <span class="curt">活动线路</span>
        <font>想玩的不一样，来这里</font>
      </h2>
      <ul>
        <li v-for="(item,i) in setActive" @click="$router.push('jukadetail?id='+item.id)">
          <div class="images">
            <el-image style="width: 100%;border-radius:6px;height:135px" :src="baseUrl+item.image" fit="cover"></el-image>
          </div>
          <div class="txtCon">
            <div class="title">{{item.title}}</div>
            <p>
              <span v-for="(vo,k) in item.tag">{{vo.name}}</span>
            </p>
            <p>带队老师：{{item.username}}</p>
            <p>时间：{{item.start_time}} ~ {{item.end_time}}</p>
            <p>
              <font>报名{{item.useTotal}}人</font>
              <font class="last" :style="item.state == 1 ? '' : (item.state == 2 ? 'color:green' : 'color:red')">{{item.state == 1 ? '报名中' : (item.state == 2 ? '进行中' : '已结束')}}</font>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div class="active" v-if="setMake.length > 0">
      <h2>
        <span class="curt">景区实况</span>
        <font>景在手中，尽在掌中</font>
      </h2>
      <dl>
        <dd v-for="(item,i) in setMake" @click="$router.push('gathermake?id='+item.id)">
          <el-image style="width: 100%;border-radius:6px;height:135px" :src="baseUrl+item.img" fit="cover"></el-image>
          <h3>{{item.title}}</h3>
          <p>{{item.address}}</p>
          <div class="price">￥{{item.rate}}
            <a>去预约<i class="el-icon-arrow-right"></i></a>
          </div>
        </dd>
      </dl>
    </div>
    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <footComponent1 :idx='0' :dx='bool'></footComponent1>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        dialogVisible:false,
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        swiperOption: {
          autoplay : {
            disableOnInteraction: false,
            delay: 5000
          },
          initialSlide: 0,
          speed: 1000,
          loop:true,
          grabCursor: true,
          autoHeight: true,   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true,
          observeParents: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        bool:0,
        setAdvert:[],
        setActive:[],
        setMake:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/juka');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        if(localStorage.getItem('cCode') == null){
          this.getQquey();
        }else{
          var cCode = JSON.parse(localStorage.getItem('cCode'));
          if(cCode.expires <= Date.parse(new Date())){
            localStorage.removeItem('cCode');
            this.getQquey();
          }else{
            this.cityData = cCode;
            this.getAdvert();
            this.getActive();
            this.getMake();
          }
        }
      }
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      gatherHref:function(){
        window.location.href= this.$url + '/main/gathercode'
      },
      kfz:function(){
        this.$alert('接口数据开发中，请稍后查收','提示');
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      getQquey:function(){
        var that = this;

        var data = {cityCode: "450100", cityName: "南宁市", expires: 1919872956000,latitude:22.78658,longitude:108.49693,key:0};
        localStorage.setItem('cCode', JSON.stringify(data));
        that.cityData = data;
        that.getAdvert();
        that.getActive();
        that.getMake();
        return false;
        
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            that.fullscreenLoading = true;
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.getAdvert();
                    that.getActive();
                    that.getMake();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAdvert:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/getAdvert',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:''
          },
          dataType:'json',
          success:function(data){
            that.setAdvert = data.data
          }
        })
      },
      getActive:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getActive',
          dataType:'json',
          success:function(data){
            that.setActive = data.data
          }
        })
      },
      getMake:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getMake',
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.setMake = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.$httpWX.post({
          url: that.$hostApi+'home/login/login',
          method:'post',
          data:{
            code:that.code
          }
        }).then(response => {
          if(response.status == 200){
            localStorage.setItem('userjwt', response.data);
            that.getQquey();
          }else{
            that.$alert(response.message, '提示');
          }
          that.fullscreenLoading = false;
        })
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  
  .jukaApp{
    max-width:750px;
    background:#ececec;
    margin:0 auto;
  }
  .jukaApp .banner{
    background:#fff;
  }
  .jukaApp .banner .swiper-container{
    width:100% !important;
  }
  .jukaApp .banner .swiper-slide{
    display:block;
  }
  .jukaApp .banner img{
    display:block;
    width:100%;
    margin:0 auto;
    object-fit: cover;
    height:260px;
  }
  .jukaApp .banner .swiper-pagination{
    bottom:10px
  }
  .jukaApp .banner .swiper-pagination span{
    width:5px;
    height:5px;
    border-radius:5px;
  }
  .jukaApp .banner .swiper-pagination span.swiper-pagination-bullet-active{
    width:15px;
    background:#fff;
    opacity:1
  }

  .jukaApp .nav{
    width:100%;
    background:#fff;
    margin:0 auto;
    padding-bottom:12px
  }
  .jukaApp .nav:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .jukaApp .nav a{
    float:left;
    width:25%;
    margin-top:15px;
    text-decoration: none
  }
  .jukaApp .nav a img{
    width:50px;
    display:block;
    margin:0 auto
  }
  .jukaApp .nav a p{
    width:100%;
    text-align:center;
    font-size:15px;
    color:#1C222B;
    padding-top:2px;
  }
  .jukaApp .noty{
    background:#fff;
    width:100%;
    padding-top:15px;
    clear:both;
  }
  .jukaApp .noty p{
    width:95%;
    margin:0 auto;
    background:#f7f8fa;
    border-radius:6px;
    font-size:15px;
    padding:10px 0;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#6b6b6b
  }
  .jukaApp .noty p i{
    color:#0059D6;
    font-size:20px;
    margin:0 3px 0 8px;
    vertical-align: top;
  }

  .jukaApp .active{
    width:96%;
    margin:0 auto;
  }
  .jukaApp .active h2{
    padding:10px 0 8px 0
  }
  .jukaApp .active h2 span{
    position:relative;
    z-index: 1;
    margin-right:12px;
    font-size:16px;
    color:#666;
    font-weight:normal
  }
  .jukaApp .active h2 span.curt{
    font-size:16px;
    color:#1C222B;
    font-weight:bold
  }
  .jukaApp .active h2 span.curt:after{
    position: absolute;
    content: '';
    width: 35px;
    height: 10px;
    border-radius: 8px;
    background-color:#6b92ff;
    top: 51%;
    right: 0px;
    z-index: -1;
  }
  .jukaApp .active h2 font{
    font-weight:normal;
    font-size:11px;
    color:#6b6b6b;
  }
  
  .jukaApp .active ul{
    width:100%;
    display:block;
  }
  .jukaApp .active ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .jukaApp .active ul li{
    background:#fff;
    padding:12px;
    margin-bottom:12px
  }
  .jukaApp .active ul li:last-child{
    margin-bottom:0;
  }
  .jukaApp .active ul li .images{
    float:left;
    width:120px;
  }

  .jukaApp .active ul li .txtCon{
    float:left;
    width:calc(100% - 130px);
    margin-left:10px
  }
  .jukaApp .active ul li .txtCon .title{
    font-size:16px;
    color:#1C222B;
    font-weight:bold;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .jukaApp .active ul li .txtCon p{
    font-size:14px;
    color:#6b6b6b;
    margin-top:10px
  }
  .jukaApp .active ul li .txtCon p span{
    font-size:11px;
    background: #FEF3E6;
    color: #ED7B2F;
    margin-right:8px;
    padding:4px;
    border-radius: 4px;
  }
  .jukaApp .active ul li .txtCon p font{
    font-size:11px;
    background: #F1F2F5;
    color: #1C222B;
    margin-right:10px;
    padding:4px;
    border-radius: 4px;
  }
  .jukaApp .active ul li .txtCon p font.last{
    background: #ECF2FE;
    color: #0052D9;
  }
  .jukaApp .active dl{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width:100%;
  }
  .jukaApp .active dl dd{
    width:49%;
    background:#fff;
    border-radius: 6px;
    padding-bottom:10px
  }
  .jukaApp .active dl dd h3{
    font-size:16px;
    width:92%;
    margin:0 auto
  }
  .jukaApp .active dl dd p{
    font-size:14px;
    color:#6b6b6b;
    width:92%;
    margin:0 auto;
    padding-top:6px
  }
  .jukaApp .active dl dd .price{
    font-size:14px;
    color:#f00;
    width:92%;
    margin:0 auto;
    font-weight:bold;
    padding-top:6px
  }
  .jukaApp .active dl dd .price a{
    float:right;
    color:#0052D9
  }
</style>